import { Response } from '@marketplace-web/core-api/api-client-util'

import { transformCurrencyAmountDto } from './currency-amount'

import {
  GetSellerInsightsPhotoRecommendationsResp,
  GetSellerInsightsResp,
} from '../types/seller-insights'

export const transformGetSellerInsightsPhotoRecommendationsResponse = (
  response: GetSellerInsightsPhotoRecommendationsResp,
) => ({
  status: response.status,
  itemsToImprove: response.items_to_improve.map(
    ({ item_id, photo_url, accessibility_description }) => ({
      itemId: item_id,
      photoUrl: photo_url,
      accessibilityDescription: accessibility_description,
    }),
  ),
})

export const transformGetSellerInsightsResponse = (response: Response<GetSellerInsightsResp>) => ({
  isVisible: response.is_visible,
  activeItemsStats: {
    ...response.active_items_stats,
    total: transformCurrencyAmountDto(response.active_items_stats.total),
  },
  soldItemsStats: {
    ...response.sold_items_stats,
    total: transformCurrencyAmountDto(response.sold_items_stats.total),
    period: {
      ...response.sold_items_stats.period,
      total: transformCurrencyAmountDto(response.sold_items_stats.period.total),
    },
  },
})
